import React from 'react';
import { Navigate } from 'react-router-dom';

import { getTSPNameByKey } from '../../tsps';
import { OAuthHandlers } from '../../tsps/types';
import { createTSPLoginMapping } from '../../tsps/utils';
import { LoginComponentProps } from '../../types/LoginFormData';
import LoginCreds from '../loginpages/LoginCreds';

interface TSPLoginFactoryProps extends LoginComponentProps {
  tsp: string;
  oAuthHandlers: OAuthHandlers;
}

/**
 * A component that returns the appropriate login component for a given TSP
 */
const TSPLoginFactory: React.FC<TSPLoginFactoryProps> = ({
  tsp,
  oAuthHandlers,
  ...props
}) => {
  // Create the mapping of TSP keys to login components
  const TSPLoginMapping = createTSPLoginMapping(oAuthHandlers, {
    TSP: tsp,
    ...props,
  });

  // Check if the TSP exists in the mapping
  if (Object.prototype.hasOwnProperty.call(TSPLoginMapping, tsp)) {
    return TSPLoginMapping[tsp]();
  }

  // If the TSP exists but doesn't have a specific login component, return the default username/password login
  if (getTSPNameByKey(tsp)) {
    return <LoginCreds onValidityChange={props.onValidityChange} />;
  }

  // If the TSP doesn't exist, redirect to the error page
  return (
    <Navigate
      to='/error'
      // Let JWT handlers determine appropriate error message and actions
    />
  );
};

export default TSPLoginFactory;
